<button type="button" (click)="handleClick($event)" (keydown.enter)="handleClick($event)" class="card">
  <div class="left-elements">
    <div class="account-name">{{entityAccount().name}}</div>
    <div class="details">
      @if (entityAccount().number) {
        <div class="account-number">{{entityAccount().number}}</div>
      }
      @if (!entityAccount().number) {
        <div class="account-number fallback-text">(Empty)</div>
      }
      @if (entityAccount().currency) {
        <div class="account-currency">{{entityAccount().currency}}</div>
      }
      @if (!entityAccount().currency) {
        <div class="account-currency fallback-text">(Empty)</div>
      }
    </div>
  </div>
  <div class="right-elements">
    <div class="account-balance">{{entityAccount().balance.displayValue}}</div>
  </div>
</button>
